/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-08-30 15:04:38
 *
 *******************************************************/
// @flow
import app01 from 'src/assets/images/dashboard-v3/recommendedApps/app01.png';
import app02 from 'src/assets/images/dashboard-v3/recommendedApps/app02.png';
import app03 from 'src/assets/images/dashboard-v3/recommendedApps/app03.png';
import app04 from 'src/assets/images/dashboard-v3/recommendedApps/app04.png';
import app05 from 'src/assets/images/dashboard-v3/recommendedApps/app05.png';
import app06 from 'src/assets/images/dashboard-v3/recommendedApps/app06.png';

export const RECOMMENDED_APPS = [
  {
    name: 'ViralSweep Giveaways Contests',
    appName: 'recommendedApp01',
    image: {
      source: app01
    },
    description: 'From $49/month. 7-day free trial.',
    detail:
      'Run viral giveaways and contests to grow your email list, boost engagement, and generate more sales!',
    rate: '4.9',
    url: 'https://apps.shopify.com/viralsweep?utm_source=boost&utm_medium=in-app&utm_content=spotlight&utm_campaign=new_installs'
  },
  {
    name: 'Address Validator Plus',
    appName: 'recommendedApp02',
    image: {
      source: app02
    },
    description: 'Free to install. Additional charges may apply.',
    detail:
      'Use shipping address validation to save money by reducing failed deliveries and returned packages.',
    rate: '4.8',
    url: 'https://apps.shopify.com/address-validator?utm_source=boost&utm_medium=in-app&utm_content=spotlight&utm_campaign=new_installs'
  },
  {
    name: 'Rich Returns',
    appName: 'recommendedApp03',
    image: {
      source: app03
    },
    description: 'From $19/month. 14-day free trial. Additional charges may apply.',
    detail:
      'Return app that automates your returns, exchanges, refunds, prepaid return labels, and store credit!',
    rate: '4.9',
    url: 'https://apps.shopify.com/rich-returns?utm_source=boost&utm_medium=in-app&utm_content=spotlight&utm_campaign=new_installs'
  },
  {
    name: 'Pre‑order Today',
    appName: 'recommendedApp04',
    image: {
      source: app04
    },
    description: 'Free plan available',
    detail:
      'Create pre order waitlists when items are sold out, out of stock, or coming soon to secure revenue',
    rate: '4.8',
    url: 'https://apps.shopify.com/pre-order-today?utm_source=boost&utm_medium=in-app&utm_content=spotlight&utm_campaign=new_installs'
  },
  {
    name: 'Checkout Bear',
    appName: 'recommendedApp05',
    image: {
      source: app05
    },
    description: 'Free to install. Additional charges may apply.',
    detail:
      'Increase your conversion rate with a powerful checkout extension and checkout editor for Plus stores.',
    raking: '5.0',
    url: 'https://apps.shopify.com/checkout-bear?utm_source=boost&utm_medium=in-app&utm_content=spotlight&utm_campaign=new_installs'
  },
  {
    name: 'Influence ‑ Loyalty & Referral',
    appName: 'recommendedApp06',
    image: {
      source: app06
    },
    description: 'Free plan available. 30-day free trial.',
    detail:
      'Launch a fully customizable loyalty & referral program in hours & scale it to fit your needs.',
    rate: '4.0',
    url: 'https://apps.shopify.com/influence-io?utm_source=boost&utm_medium=in-app&utm_content=spotlight&utm_campaign=new_installs'
  }
];
